import { Typography } from 'antd';
import { ReactComponent as CheckIcon } from 'assets/icons/Check.svg';
import { ReactComponent as ChevronStepsSeparator } from 'assets/icons/ChevronStepsSeparator.svg';
import clsx from 'clsx';
import React from 'react';

type Step = {
  key: number;
  title: string;
};

export function ChevronSteps({
  currentStep = 0,
  steps,
}: {
  currentStep: number; // 0-based
  steps: Step[];
}) {
  return (
    <div className="w-full mb-[-2px] flex items-center">
      {steps.map((s, idx) => {
        const isActive = idx === currentStep;
        const isDone = idx < currentStep;

        return (
          <React.Fragment key={s.key}>
            <div
              className={clsx(
                'flex items-center gap-2',
                'rounded-md px-2 py-1',
              )}
              aria-current={isActive ? 'step' : undefined}
            >
              <span
                className={clsx(
                  'flex h-8 w-8 items-center justify-center rounded-full text-xs font-semibold',
                  isActive
                    ? 'bg-bleu-hellio-500 text-white'
                    : isDone
                      ? ''
                      : 'bg-gris-industriels-6 text-white',
                )}
              >
                {isDone ? (
                  <CheckIcon className="h-8 w-8 p-2 text-3xl text-bleu-hellio bg-bleu-clair-hellio rounded-full" />
                ) : (
                  idx + 1
                )}
              </span>

              <Typography.Text
                className={clsx(
                  '!m-0 text-sm',
                  isActive
                    ? 'text-bleu-hellio-500 font-semibold'
                    : isDone
                      ? 'text-bleu-hellio-6 font-medium'
                      : 'text-gray-400 font-medium',
                )}
              >
                {s.title}
              </Typography.Text>
            </div>

            {idx !== steps.length - 1 && (
              <div className="mx-2 flex items-center">
                <ChevronStepsSeparator aria-hidden="true" />
              </div>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
